import { checkRolePermission } from '../services/jwt'
async function guardRoute(to, from, next) {
  var isAuthenticated = false
  if (window.localStorage.getItem('token')) {
    isAuthenticated = true
  } else {
    isAuthenticated = false
  }

  if (isAuthenticated) {
    await checkRolePermission()
    const rolePermissions = JSON.parse(window.localStorage.getItem('RolePermission'))

    const hasRolePermission = rolePermissions.find(
      (rp) =>
        rp.link && rp.link.startsWith(rp.link.split('/')[1], 1) === to.fullPath.startsWith(to.fullPath.split('/')[1], 1) && rp.link.split('/')[2] === to.fullPath.split('/')[2],
    )
    let hasSubItemsRolePermission
    rolePermissions.forEach((rp) => {
      if (rp.subItems.length) {
        return (hasSubItemsRolePermission = rp.subItems.find(
          (srp) => srp.link.startsWith(srp.link.split('/')[1], 1) === to.fullPath.startsWith(to.fullPath.split('/')[1], 1) && srp.link.split('/')[2] === to.fullPath.split('/')[2],
        ))
      }
    })
    if (!hasRolePermission && !hasSubItemsRolePermission) next(rolePermissions[0].link)
    else next()
  } else {
    next('/login')
  }
}

export default [
  {
    path: '/',
    name: 'default',
    beforeEnter: guardRoute,
    component: () => import('../layouts/main.vue'),
    children: [
      {
        path: '/teamtasktest',
        name: 'teamtask-test',
        component: () => import('../views/teamtaskTest/teamtaskTest'),
        beforeEnter: guardRoute,
      },
      {
        path: '/main-dashboard',
        name: 'main-dashboard',
        beforeEnter: guardRoute,
        component: () => import('../views/dashboards/default'),
      },
      {
        path: '/teamtask/table/:slug',
        name: 'teamtaskTable',
        beforeEnter: guardRoute,
        component: () => import('../views/teamtask/table'),
        children: [
          {
            path: 'page/:page',
            name: 'teamtaskPages',
            beforeEnter: guardRoute,
            component: () => import('../views/teamtask/table'),
          },
        ],
      },
      {
        path: '/teamtask/:slug/details/:id',
        name: 'teamTaskDetails',
        beforeEnter: guardRoute,
        component: () => import('../views/teamtask/details'),
      },
      {
        path: '/teamtask',
        name: 'teamTask',
        beforeEnter: guardRoute,
        redirect: { name: 'teamtaskTable' },
      },
      {
        path: '/teamtask/board/:slug',
        name: 'teamTaskBoardDetails',
        beforeEnter: guardRoute,
        component: () => import('../views/teamtask/kanbanBoard'),
      },
      {
        path: '/list/:slug',
        name: 'list',
        beforeEnter: guardRoute,
        component: () => import('../views/lists/list'),
      },
      // {
      //   path: '/list/courses/:courseId/comments',
      //   name: 'comments',
      //   beforeEnter: guardRoute,
      //   component: () => import('../views/lists/list'),
      //   children: [
      //     {
      //       path: 'waiting',
      //       name: 'comments-waiting',
      //       beforeEnter: guardRoute,
      //       component: () => import('../views/lists/list'),
      //     },
      //     {
      //       path: 'approved',
      //       name: 'comments-approved',
      //       beforeEnter: guardRoute,
      //       component: () => import('../views/lists/list'),
      //     },
      //     {
      //       path: 'failed',
      //       name: 'comments-failed',
      //       beforeEnter: guardRoute,
      //       component: () => import('../views/lists/list'),
      //     },
      //   ],
      // },

      {
        path: '/list/invoice/add',
        name: 'addInvoice',
        component: () => import('../views/lists/invoice/'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/invoice/:slug/:id',
        name: 'invoiceDetail',
        component: () => import('../views/lists/invoice/'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/product/add',
        name: 'addProduct',
        component: () => import('../views/lists/product/add.vue'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/product/:slug/:id',
        name: 'productDetail',
        component: () => import('../views/lists/product/add.vue'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/user/add',
        name: 'addUser',
        component: () => import('../views/lists/user/Add.vue'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/address/add',
        name: 'user-address',
        component: () => import('../views/user/add-address.vue'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/user/:slug/:id',
        name: 'userDetail',
        component: () => import('../views/lists/user/Detail.vue'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/users/add',
        name: 'addDadbananUser',
        component: () => import('../views/dadban/users/Add.vue'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/users/:slug/:id',
        name: 'dadbananUserDetail',
        component: () => import('../views/dadban/users/Detail.vue'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/specificUserWalletTransactions/fromUserManagement/:slug/:id',
        name: 'transactions-fromUserManagement',
        component: () => import('../views/lists/list.vue'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/specificUserWalletTransactions/fromListsWallet/:slug/:id',
        name: 'transactions-fromListsWallet',
        component: () => import('../views/lists/list.vue'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/color/add',
        component: () => import('../views/lists/product/advance/color.vue'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/color/:slug/:id',
        component: () => import('../views/lists/product/advance/color.vue'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/size/add',
        component: () => import('../views/lists/product/advance/size.vue'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/size/:slug/:id',
        component: () => import('../views/lists/product/advance/size.vue'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/guarantee/add',
        component: () => import('../views/lists/product/advance/gurantee.vue'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/guarantee/:slug/:id',
        component: () => import('../views/lists/product/advance/gurantee.vue'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/cryptotransaction/:slug/:id',
        name: 'crypto-transaction',
        component: () => import('../views/lists/crypto/detailCryptoTransaction.vue'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/tomantransaction/:slug/:id',
        name: 'toman-transaction',
        component: () => import('../views/lists/crypto/tomanTransactionDetail.vue'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/userwalletcoincryptotransaction/:slug/:id',
        name: 'crypto-transaction-from-wallet',
        component: () => import('../views/lists/crypto/detailCryptoTransaction.vue'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/usercoincryptotransaction/:slug/:id',
        name: 'crypto-transaction-from-user',
        component: () => import('../views/lists/crypto/detailCryptoTransaction.vue'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/cryptocurrency/:slug/:id',
        name: 'crypto-details',
        component: () => import('../views/lists/crypto/cryptoDetails.vue'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/cryptonetwork/:slug/:id',
        name: 'crypto-networks',
        component: () => import('../views/lists/crypto/networkDetails.vue'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/invitation/add',
        name: 'invitation-setting',
        component: () => import('../views/lists/invitation/index.vue'),
        beforeEnter: guardRoute,
      },
      {
        path: '/categories',
        name: 'categories',
        beforeEnter: guardRoute,
        component: () => import('../views/categories/index.vue'),
      },
      {
        path: '/categories/formbuilder/detail/:id',
        name: 'categoriesFormBuilder',
        beforeEnter: guardRoute,
        component: () => import('../views/categories/formBuilder.vue'),
      },
      {
        path: '/settings/firstbanner',
        name: 'dadban-first-banner',
        component: () => import('../views/dadban/bannersSetting/AddFirstBanner.vue'),
        beforeEnter: guardRoute,
      },
      {
        path: '/settings/thirdbanner',
        name: 'dadban-statistics-banner',
        component: () => import('../views/dadban/bannersSetting/AddStatisticsBanner.vue'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/slider/add',
        name: 'dadban-slider-banner',
        component: () => import('../views/dadban/bannersSetting/AddSliderBanner.vue'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/slider/detail/:id',
        name: 'dadban-detail-slider-banner',
        component: () => import('../views/dadban/bannersSetting/UpdateSliderBanner.vue'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/advertisings/add',
        name: 'dadban-add-advertisings',
        component: () => import('../views/dadban/advertisings/add.vue'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/advertisings/detail/:id',
        name: 'dadban-detail-advertisings',
        component: () => import('../views/dadban/advertisings/edit.vue'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/practice/detail/:practiceId',
        name: 'dadbanan-practice',
        component: () => import('../views/dadban/teachers/practicDetail.vue'),
        beforeEnter: guardRoute,
      },
      // {
      //   path: '/list/teacherskilluppractice/detail/:practiceId',
      //   name: 'teacher-skillUp-practice',
      //   component: () => import('../views/skillUp/teachers/WorkoutDetail.vue'),
      //   beforeEnter: guardRoute,
      // },
      {
        path: '/crm',
        name: 'Crm',
        beforeEnter: guardRoute,
        component: () => import('../views/adminCrm/CrmLayout'),
        redirect: '/crm/dashboard',
        children: [
          {
            path: '/crm/dashboard',
            name: 'dashborad',
            beforeEnter: guardRoute,
            component: () => import('../views/adminCrm/Crm'),
          },
          {
            path: '/crm/user-information/:id',
            name: 'UserInformation',
            beforeEnter: guardRoute,
            component: () => import('../views/adminCrm/UserInformation'),
          },
        ],
      },

      {
        path: '/varieties/:id',
        name: 'list-varieties',
        component: () => import('../views/lists/varieties.vue'),
        beforeEnter: guardRoute,
      },
      {
        path: '/printInvoice/:id',
        name: 'printInvoice',
        component: () => import('../views/invoice/PrintInvoice'),
      },
      {
        path: '/printInvoice/print/:id',
        name: 'print',
        component: () => import('../views/invoice/Print'),
      },
      {
        path: '/superAdmin',
        name: 'superAdminList',
        component: () => import('../views/superAdmin/listSuperAdmin'),
        beforeEnter: guardRoute,
      },
      {
        path: '/superadmin/:slug',
        name: 'admin-Kanban',
        component: () => import('../views/superAdmin/singlePage.vue'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/teachers/add',
        name: 'dadban-add-teachers',
        component: () => import('../views/dadban/teachers/add'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/teachers/detail/:id',
        name: 'dadban-edit-teachers',
        component: () => import('../views/dadban/teachers/edit'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/mentors/add',
        name: 'dadban-add-mentors',
        component: () => import('../views/dadban/mentors/add'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/mentors/detail/:id',
        name: 'dadban-edit-mentors',
        component: () => import('../views/dadban/mentors/edit'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/courses/:slug',
        name: 'dadban-courses',
        component: () => import('../views/dadban/courses'),
        beforeEnter: guardRoute,
        children: [
          {
            path: '/list/courses/add',
            name: 'dadban-add-courses',
            component: () => import('../views/dadban/courses/add'),
            beforeEnter: guardRoute,
          },
          {
            path: '/list/courses/questions/:courseId',
            name: 'dadban-question-courses',
            component: () => import('../views/dadban/courses/questions'),
            beforeEnter: guardRoute,
          },
          {
            path: '/list/courses/:courseId/headlines',
            name: 'dadban-headlines-courses',
            component: () => import('../views/dadban/courses/headlines'),
            beforeEnter: guardRoute,
          },
          {
            path: '/list/courses/:courseId/comments',
            name: 'comments-courses',
            component: () => import('../views/lists/list'),
            beforeEnter: guardRoute,
            children: [
              {
                path: 'waiting',
                name: 'comments-waiting',
                component: () => import('../views/lists/list'),
                beforeEnter: guardRoute,
              },
              {
                path: 'approved',
                name: 'comments-approved',
                beforeEnter: guardRoute,
                component: () => import('../views/lists/list'),
              },
              {
                path: 'failed',
                name: 'comments-failed',
                beforeEnter: guardRoute,
                component: () => import('../views/lists/list'),
              },
            ],
          },
          {
            path: '/list/courses/:courseId/comments/comments/detail/:commentId',
            name: 'comment',
            beforeEnter: guardRoute,
            component: () => import('../views/comment/'),
          },
          {
            path: '/list/courses/:courseId/comments/detail/:commentId',
            name: 'comment',
            beforeEnter: guardRoute,
            component: () => import('../views/comment/'),
          },
          {
            path: '/list/courses/detail/:courseId',
            name: 'dadban-edit-courses',
            component: () => import('../views/dadban/courses/edit'),
            beforeEnter: guardRoute,
          },
          {
            path: '/list/courses/:courseId/courseprerequisites',
            name: 'course-prerequisites',
            component: () => import('../views/lists/list.vue'),
            beforeEnter: guardRoute,
          },
          {
            path: '/list/courses/:courseId/users',
            name: 'course-users',
            component: () => import('../views/lists/list'),
            beforeEnter: guardRoute,
          },
        ],
      },
      {
        path: '/list/packages',
        name: 'dadban-packages',
        component: () => import('../views/dadban/packages'),
        beforeEnter: guardRoute,
        children: [
          {
            path: '/list/packages/add',
            name: 'dadban-add-packages',
            component: () => import('../views/dadban/packages/add'),
            beforeEnter: guardRoute,
          },
          {
            path: '/list/packages/detail/:packageId',
            name: 'dadban-edit-packages',
            component: () => import('../views/dadban/packages/edit'),
            beforeEnter: guardRoute,
          },
          {
            path: '/list/packages/questions/:packageId',
            name: 'dadban-question-packages',
            component: () => import('../views/dadban/packages/questions'),
            beforeEnter: guardRoute,
          },
          {
            path: '/list/packages/:packageId/packagecomments',
            name: 'comments-packages',
            component: () => import('../views/lists/list'),
            beforeEnter: guardRoute,
            children: [
              {
                path: 'waiting',
                name: 'comments-waiting',
                component: () => import('../views/lists/list'),
                beforeEnter: guardRoute,
              },
              {
                path: 'approved',
                name: 'comments-approved',
                beforeEnter: guardRoute,
                component: () => import('../views/lists/list'),
              },
              {
                path: 'failed',
                name: 'comments-failed',
                beforeEnter: guardRoute,
                component: () => import('../views/lists/list'),
              },
            ],
          },
          {
            path: '/list/packages/:packageId/packagecomments/detail/:commentId',
            name: 'comment',
            beforeEnter: guardRoute,
            component: () => import('../views/comment/'),
          },
          {
            path: '/list/packages/:packageId/packagecourses',
            name: 'courses-package',
            component: () => import('../views/lists/list'),
            beforeEnter: guardRoute,
          },
          {
            path: '/list/packages/:packageId/packageprerequisites',
            name: 'package-prerequisites',
            component: () => import('../views/lists/list'),
            beforeEnter: guardRoute,
          },
          {
            path: '/list/packages/:packageId/users',
            name: 'course-users',
            component: () => import('../views/lists/list'),
            beforeEnter: guardRoute,
          },
        ],
      },
      {
        path: '/list/articles/add',
        name: 'dadban-add-articles',
        component: () => import('../views/dadban/articles/add'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/articles/detail/:id',
        name: 'dadban-edit-articles',
        component: () => import('../views/dadban/articles/edit'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/posts/add',
        name: 'dadban-add-posts',
        component: () => import('../views/dadban/posts/add.vue'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/posts/detail/:id',
        name: 'dadban-edit-posts',
        component: () => import('../views/dadban/posts/edit.vue'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/totalcomments/detail/:id',
        name: 'dadbanan-user-comments',
        component: () => import('../views/dadban/comments/userComments.vue'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/ruleandregulation/add',
        name: 'dadban-add-rules',
        component: () => import('../views/dadban/rules/add'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/ruleandregulation/detail/:id',
        name: 'dadban-edit-rules',
        component: () => import('../views/dadban/rules/edit'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/adminstudents/add',
        name: 'dadban-add-students',
        component: () => import('../views/dadban/students/add'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/adminstudents/detail/:id',
        name: 'dadban-edit-students',
        component: () => import('../views/dadban/students/edit'),
        beforeEnter: guardRoute,
      },
      {
        path: '/redirecturl',
        name: 'dadban-redirect',
        component: () => import('../views/dadban/redirect'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/orders/detail/:id',
        name: 'dadban-detail-orders',
        component: () => import('../views/dadban/orders/detail'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/universityorders/detail/:id',
        name: 'mooc-detail-orders',
        component: () => import('../views/mooc/orders/details.vue'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/discount/detail/:id',
        name: 'dadban-edit-discount',
        component: () => import('../views/dadban/discount/edit'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/discount/add',
        name: 'dadban-add-discount',
        component: () => import('../views/dadban/discount/add'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/universityfaculties/add',
        name: 'mooc-add-faculties',
        component: () => import('../views/mooc/technical-admin/faculties/add'),
        beforeEnter: guardRoute,
      },
      {
        path: '/universitylicense/print/:type/:courseId',
        name: 'mooc-print-licenses',
        component: () => import('../views/mooc/issuance-certificate/PrintCertificates.vue'),
      },
      {
        path: '/list/universityfaculties/detail/:id',
        name: 'mooc-edit-faculties',
        component: () => import('../views/mooc/technical-admin/faculties/edit'),
        beforeEnter: guardRoute,
      },
      {
        path: '/universityfacultiesextra',
        name: 'mooc-edit-faculty',
        component: () => import('../views/mooc/head-admin/faculties/edit'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/universitycourses',
        name: 'mooc-courses',
        component: () => import('../views/mooc/courses'),
        beforeEnter: guardRoute,
        children: [
          {
            path: '/list/universitycourses/add',
            name: 'mooc-add-courses',
            component: () => import('../views/mooc/courses/add'),
            beforeEnter: guardRoute,
          },
          {
            path: '/list/universitycourses/detail/:courseId',
            name: 'mooc-edit-courses',
            component: () => import('../views/mooc/courses/edit'),
            beforeEnter: guardRoute,
          },
          {
            path: '/list/universitycourses/:courseId/users',
            name: 'course-users',
            component: () => import('../views/lists/list'),
            beforeEnter: guardRoute,
          },
        ],
      },
      {
        path: '/list/shortuniversitypackages',
        name: 'mooc-packages',
        component: () => import('../views/mooc/packages'),
        beforeEnter: guardRoute,
        children: [
          {
            path: '/list/shortuniversitypackages/add',
            name: 'mooc-add-packages',
            component: () => import('../views/mooc/packages/add'),
            beforeEnter: guardRoute,
          },
          {
            path: '/list/shortuniversitypackages/detail/:packageId',
            name: 'mooc-edit-packages',
            component: () => import('../views/mooc/packages/edit'),
            beforeEnter: guardRoute,
          },
          {
            path: '/list/shortuniversitypackages/:packageId/users',
            name: 'course-users',
            component: () => import('../views/lists/list'),
            beforeEnter: guardRoute,
          },
          {
            path: '/list/shortuniversitypackages/:packageId/universitypackagecourses',
            name: 'courses-package',
            component: () => import('../views/lists/list'),
            beforeEnter: guardRoute,
          },
        ],
      },
      {
        path: '/list/longuniversitypackages',
        name: 'mooc-packages',
        component: () => import('../views/mooc/packages'),
        beforeEnter: guardRoute,
        children: [
          {
            path: '/list/longuniversitypackages/add',
            name: 'mooc-add-packages',
            component: () => import('../views/mooc/packages/add'),
            beforeEnter: guardRoute,
          },
          {
            path: '/list/longuniversitypackages/detail/:packageId',
            name: 'mooc-edit-packages',
            component: () => import('../views/mooc/packages/edit'),
            beforeEnter: guardRoute,
          },
          {
            path: '/list/longuniversitypackages/:packageId/users',
            name: 'course-users',
            component: () => import('../views/lists/list'),
            beforeEnter: guardRoute,
          },
          {
            path: '/list/longuniversitypackages/:packageId/universitypackagecourses',
            name: 'courses-package',
            component: () => import('../views/lists/list'),
            beforeEnter: guardRoute,
          },
        ],
      },
      {
        path: '/list/facultyshortuniversitypackages',
        name: 'mooc-packages',
        component: () => import('../views/mooc/packages'),
        beforeEnter: guardRoute,
        children: [
          {
            path: '/list/facultyshortuniversitypackages/add',
            name: 'mooc-add-packages',
            component: () => import('../views/mooc/packages/add'),
            beforeEnter: guardRoute,
          },
          {
            path: '/list/facultyshortuniversitypackages/detail/:packageId',
            name: 'mooc-edit-packages',
            component: () => import('../views/mooc/packages/edit'),
            beforeEnter: guardRoute,
          },
          {
            path: '/list/facultyshortuniversitypackages/:packageId/users',
            name: 'course-users',
            component: () => import('../views/lists/list'),
            beforeEnter: guardRoute,
          },
          {
            path: '/list/facultyshortuniversitypackages/:packageId/universitypackagecourses',
            name: 'courses-package',
            component: () => import('../views/lists/list'),
            beforeEnter: guardRoute,
          },
        ],
      },
      {
        path: '/list/facultylonguniversitypackages',
        name: 'mooc-packages',
        component: () => import('../views/mooc/packages'),
        beforeEnter: guardRoute,
        children: [
          {
            path: '/list/facultylonguniversitypackages/add',
            name: 'mooc-add-packages',
            component: () => import('../views/mooc/packages/add'),
            beforeEnter: guardRoute,
          },
          {
            path: '/list/facultylonguniversitypackages/detail/:packageId',
            name: 'mooc-edit-packages',
            component: () => import('../views/mooc/packages/edit'),
            beforeEnter: guardRoute,
          },
          {
            path: '/list/facultylonguniversitypackages/:packageId/users',
            name: 'course-users',
            component: () => import('../views/lists/list'),
            beforeEnter: guardRoute,
          },
          {
            path: '/list/facultylonguniversitypackages/:packageId/universitypackagecourses',
            name: 'courses-package',
            component: () => import('../views/lists/list'),
            beforeEnter: guardRoute,
          },
        ],
      },
      {
        path: '/list/facultyuniversitycourses',
        name: 'mooc-courses',
        component: () => import('../views/mooc/courses'),
        beforeEnter: guardRoute,
        children: [
          {
            path: '/list/facultyuniversitycourses/add',
            name: 'mooc-add-courses',
            component: () => import('../views/mooc/courses/add'),
            beforeEnter: guardRoute,
          },
          {
            path: '/list/facultyuniversitycourses/detail/:courseId',
            name: 'mooc-edit-courses',
            component: () => import('../views/mooc/courses/edit'),
            beforeEnter: guardRoute,
          },
          {
            path: '/list/facultyuniversitycourses/:courseId/headlines',
            name: 'mooc-headlines-courses',
            component: () => import('../views/mooc/courses/headlines'),
            beforeEnter: guardRoute,
          },
          {
            path: '/list/universitycourses/:courseId/headlines',
            name: 'mooc-headlines-courses',
            component: () => import('../views/mooc/courses/headlines'),
            beforeEnter: guardRoute,
          },
          {
            path: '/list/facultyuniversitycourses/:courseId/users',
            name: 'course-users',
            component: () => import('../views/lists/list'),
            beforeEnter: guardRoute,
          },
        ],
      },
      {
        path: '/list/manageusers/add',
        name: 'mooc-add-users',
        component: () => import('../views/mooc/technical-admin/users/add.vue'),
        beforeEnter: guardRoute,
      },
      {
        path: 'list/universitylicense/detail/:courseId',
        name: 'mooc-issuance-certificate',
        component: () => import('../views/mooc/issuance-certificate/Certificates.vue'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/manageusers/detail/:id',
        name: 'mooc-edit-users',
        component: () => import('../views/mooc/technical-admin/users/edit.vue'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/universityteachers/add',
        name: 'mooc-add-teachers',
        component: () => import('../views/mooc/teachers/add'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/universityteachers/detail/:id',
        name: 'mooc-edit-teachers',
        component: () => import('../views/mooc/teachers/edit'),
        beforeEnter: guardRoute,
      },
      {
        path: '/list/campaigns/detail/:id',
        name: 'campaign-detail',
        beforeEnter: guardRoute,
        component: () => import('../views/dadban/campaigns/detail.vue'),
      },
      {
        path: '/list/campaigns/add',
        name: 'campaign-detail',
        beforeEnter: guardRoute,
        component: () => import('../views/dadban/campaigns/detail.vue'),
      },
    ],
  },
  // login
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/account/login'),
  },
  {
    path: '/sendVerifyToken',
    name: 'sendVerifyToken',
    component: () => import('../views/account/SendVerifyToken'),
  },
  {
    path: '/checkVerifyToken',
    name: 'checkVerifyToken',
    component: () => import('../views/account/CheckVerifyToken'),
  },
  {
    path: '/resetPassword',
    name: 'resetpassword',
    component: () => import('../views/account/ResetPassword'),
  },
  {
    path: '/list/allbalancewithuserinfo/detail/:transactionId',
    name: 'userTransactionDetail',
    beforeEnter: guardRoute,
    component: () => import('../views/dadban/wallet/Wallet.vue'),
  },
  {
    path: '/list/allbalancewithuserinfo/transactionDetail/:id',
    name: 'userTransactionDetailBaseOnStatus',
    beforeEnter: guardRoute,
    component: () => import('../views/dadban/wallet/TransactionDetail.vue'),
  },
  {
    path: '/list/alltransactions/detail/:id',
    name: 'userTransactionDetailBaseOnStatus',
    beforeEnter: guardRoute,
    component: () => import('../views/dadban/wallet/TransactionDetail.vue'),
  },
  {
    path: '/list/allbalancewithuserinfo/add',
    name: 'groupFinancialTransfer',
    beforeEnter: guardRoute,
    component: () => import('../views/dadban/wallet/GroupTransaction.vue'),
  },
  {
    path: '/customerclub',
    name: 'dadbanan-customers-club',
    beforeEnter: guardRoute,
    component: () => import('../views/dadban/customersClub/CustomersClub.vue'),
  },
]
